// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Word_wrapper__1fL4w","punctuation":"Word_punctuation__2gxLm"};